/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Type_MotorbikeInputs */

const vi_vehicle_type_motorbike = /** @type {(inputs: Vehicle_Type_MotorbikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xe máy`)
};

/**

* @param {Vehicle_Type_MotorbikeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_type_motorbike = /** @type {((inputs?: Vehicle_Type_MotorbikeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Type_MotorbikeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_type_motorbike(inputs)
});